import React, { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

interface Props {
  expirationDate: string // MM/YY
}

enum ContractorPortalPaymentMethodChipStatus {
  Active = 'active',
  ExpiresSoon = 'expires_soon',
  Expired = 'expired',
}

const contractorStatusMap = {
  [ContractorPortalPaymentMethodChipStatus.Active]: {
    textStyle: tw`text-success-500`,
    text: 'Active',
    bgStyle: tw`bg-success-200`,
  },
  [ContractorPortalPaymentMethodChipStatus.Expired]: {
    textStyle: tw`text-critical-500`,
    text: 'Expired',
    bgStyle: tw`bg-critical-200`,
  },
  [ContractorPortalPaymentMethodChipStatus.ExpiresSoon]: {
    textStyle: tw`text-warning-500`,
    text: 'Expires Soon',
    bgStyle: tw`bg-warning-200`,
  },
}

const ContractorPortalPaymentMethodChipComponent = ({ expirationDate }: Props) => {
  const status = useMemo(() => {
    const expDate = dayjs(expirationDate, 'MM/YY').endOf('month')

    const now = dayjs().startOf('month')

    if (expDate.isBefore(now)) {
      return ContractorPortalPaymentMethodChipStatus.Expired
    }

    if (expDate.isSame(now, 'month') || expDate.isSame(now.add(1, 'month'), 'month')) {
      return ContractorPortalPaymentMethodChipStatus.ExpiresSoon
    }

    return ContractorPortalPaymentMethodChipStatus.Active
  }, [expirationDate])

  return (
    <Chip
      className={contractorStatusMap[status].bgStyle}
      textClassName={contractorStatusMap[status].textStyle}
      text={contractorStatusMap[status].text}
    />
  )
}

export const ContractorPortalPaymentMethodChip = memo(ContractorPortalPaymentMethodChipComponent)
